import React, { Component } from 'react';
import { Spin, Table, Tooltip, Button, Card, Icon, InputNumber, Col, Row, Modal, Select, Pagination } from 'antd';
import { sanitizerTexto, getStatusInv, getStatusInvColor } from '../../util/utilerias';
import { openNotification } from '../../util/notificaciones';
import CatalogoRequest from '../../services/Catalogo';
import { get_id } from '../../util/IdUser';
import InventarioRequest from '../../services/Inventario';
import VistaInventario from './VistaInventario';
import DetallesSAP from './DetallesSAP';
import { roles } from '../../util/Roles';
import moment from 'moment';
import Timer from '../Timer/Timer';
import { withRouter } from "react-router";
import { Link } from 'react-router-dom';
import { esBarras, getSegmento } from '../../util/generics';
moment.locale('es')
const rol = localStorage.getItem("role")?.split(",");
const { confirm } = Modal;
const { Option } = Select

/**
 * Evento para cancelar el scroll en input number
 */
document.addEventListener("wheel", function (event) {
    if (document.activeElement.type === "number") {
        document.activeElement.blur();
    }
});

/**
 * Clase para ver el proceso de mostrar artículos del inventario
 */
export default class ListaInventarioPT extends Component {
    state = {
        arrListaInventario: [],
        filterText: "",
        cargando: false,
        bloquear_guardar: true,
        arrDrives: [],
        driveSelected: undefined,
        scroll: { x: 1050, y: 500 },
        disable_combo_drive: false,
        mostrar_modal_articulos: false,
        arr_articulos_error: [],
        mostrar_variacion: false,
        paginacion: {},
        pageSize: 100,
        totalArticulos: 0,
        FechaStr: ""
    }

    /**
     * Comportamiento del componente al mostrar los artículos
     */
    componentDidMount = () => {
        let state = { ...this.state };
        const segmento = getSegmento()
        if (!segmento || esBarras()) {
            const location = {
                pathname: "/",
            }
            this.setState(state, this.props.history.push(location))
        } else {
            const script = document.createElement("script");
            script.src = "https://kit.fontawesome.com/a076d05399.js";
            script.async = true;
            script.crossorigin = 'anonymous';
            document.body.appendChild(script);

            CatalogoRequest.CargarSitiosByUsuario(get_id()).then(response => {
                state.arrDrives = response.data
                let fecha = new Date();
                fecha.setHours(fecha.getHours());
                state.FechaStr = fecha.toLocaleDateString();
                this.setState(state, () => {
                    if (response.data.length === 1) {
                        this.setState({ driveSelected: response.data[0].id }, this.onChangeDrive)
                    } else {
                        let elSitio = response.data.find((item) => item.id == (this.props.match.params.idSitio * 1));
                        if (elSitio != undefined) {
                            this.setState({ driveSelected: (this.props.match.params.idSitio * 1) }, this.onChangeDrive);
                        }
                    }
                    if (!response.data.length) {
                        if (rol.includes(roles.Operador)) {
                            openNotification(
                                "El usuario no tiene asignado un punto de venta, favor de contactar al Administrador.",
                                "Error"
                            )
                        } else {
                            openNotification(
                                "El usuario no tiene asignado un punto de venta, deberá configurarlo en el módulo de usuarios.",
                                "Aviso"
                            )
                        }
                    }
                })
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al listar los puntos de venta del usuario.",
                    "Error"
                )
            })
        }
    }

    componentWillReceiveProps(props) {
        //this.componentDidMount();
    }

    /**
     * Se ejecuta cuando se cambia un drive
     */
    onChangeDrive = () => {
        let state = { ...this.state };
        this.setState({ cargando: true }, () => {
            if (state.driveSelected) {
                InventarioRequest.ListarInventarioPT(state.driveSelected, this.props.match.params.esExterno).then(response => {
                    state.paginacion = {
                        current: 1,
                        total: response.data.count,
                        onChange: this.handlePaginaChange,
                        pageSize: 100,
                        showTitle: false
                    }
                    state.bloquear_guardar = false;
                    state.cargando = false;
                    
                    let toDay = new Date();
                    const utcTimeOffset = toDay.getTimezoneOffset() / 60;
                    let today = new Date().toLocaleDateString();
                    response.data.results.find((item) => {
                        let toDy = new Date(item.Fecha);
                        toDy.setHours(toDy.getHours() + 7);
                        item.Fecha2 = new Date(item.Fecha);
                        item.Fecha2.setHours(item.Fecha2.getHours() + utcTimeOffset);
                        item.FechaStr = toDy.toLocaleDateString();
                        if (today != item.FechaStr) {
                            toDy.setDate(toDy.getDate() + 1)
                            item.FechaStr = toDy.toLocaleDateString();
                        }
                        if (item.FechaStr == today && item.Estatus != 5) {
                            state.bloquear_guardar = true;
                        }
                    });
                    state.arrListaInventario = response.data.results;
                    state.disableRange = false;
                    this.setState(state)
                }).catch(err => {
                    this.setState({ cargando: false });
                    openNotification(
                        "Ha ocurrido un error al listar el histórico del drive seleccionado.",
                        "Error"
                    )
                })
            } else {
                state.cargando = false;
                state.paginacion.total = 0;
                state.arrListaInventario = [];
                state.disableRange = true;
                state.dateStrings = [];
                state.fecha_historico = [];
                this.setState(state)
            }
        })
    }

    /**
     * Mostrarl el modal de formulario de inventario
     * @param: type. acción que elige el usuario entre ver o editar
     * @param: record. objecto de inventario seleccionado
     * @return: nada, se usa el valor para mostrar datos específicos
     */
    showForm = (type, _, record) => {
        this.setState({ typeForm: type, objInventario: record, visible: true })
    }

    showFormSAP = (type, _, record) => {
        this.setState({ typeForm: type, objInventario: record, visibleSAP: true })
    }

    /**
     * Función para esconder modal de detalle de inventario
     * @param: value. true o false
     * @return: nada
     */
    esconderModal = (value) => {
        let state = { ...this.state }
        state.visible = false;
        state.visibleSAP = false;
        state.objInventario = null;
        this.setState(state, () => {
            if (value) this.onChangeDrive()
        })
    }

    sincSAP = (value, record) => {
        let state = { ...this.state };
        this.setState({ cargando: true }, () => {
            InventarioRequest.SincronizarInventarioSAP(state.driveSelected, this.props.match.params.esExterno, record.id).then(response => {
                state.paginacion = {
                    current: 1,
                    total: response.data.count,
                    onChange: this.handlePaginaChange,
                    pageSize: 100,
                    showTitle: false
                }
                state.bloquear_guardar = false;
                let today = new Date().toLocaleDateString();
                response.data.results.find((item) => {
                    let toDy = new Date(item.Fecha);
                    item.Fecha2 = new Date(item.Fecha);
                    item.Fecha2.setHours(item.Fecha2.getHours() + 7);
                    item.FechaStr = toDy.toLocaleDateString();
                    if (today != item.FechaStr) {
                        toDy.setDate(toDy.getDate() + 1)
                        item.FechaStr = toDy.toLocaleDateString();
                    }
                    if (item.FechaStr == today && item.Estatus != 5) {
                        state.bloquear_guardar = true;
                    }
                });

                state.cargando = false;
                state.arrListaInventario = response.data.results
                state.disableRange = false;
                this.setState(state)
            }).catch(err => {
                this.setState({ cargando: false });
                console.log(err)
                openNotification(
                    "Ha ocurrido un error al sincronizar con SAP. Favor de intentarlo más tarde",
                    "Error"
                )
            })
        })
    }

    deleteInv = (record) => {
        let state = { ...this.state };
        this.setState({ cargando: true }, () => {
            InventarioRequest.EliminarInventario(state.driveSelected, this.props.match.params.esExterno, record.id).then(response => {
                state.paginacion = {
                    current: 1,
                    total: response.data.count,
                    onChange: this.handlePaginaChange,
                    pageSize: 100,
                    showTitle: false
                }
                state.bloquear_guardar = false;
                let today = new Date().toLocaleDateString();
                response.data.results.find((item) => {
                    let toDy = new Date(item.Fecha);
                    item.Fecha2 = new Date(item.Fecha);
                    item.Fecha2.setHours(item.Fecha2.getHours() + 7);
                    item.FechaStr = toDy.toLocaleDateString();
                    if (today != item.FechaStr) {
                        toDy.setDate(toDy.getDate() + 1)
                        item.FechaStr = toDy.toLocaleDateString();
                    }
                    if (item.FechaStr == today && item.Estatus != 5) {
                        state.bloquear_guardar = true;
                    }
                });

                state.cargando = false;
                state.arrListaInventario = response.data.results
                state.disableRange = false;
                this.setState(state)
            }).catch(err => {
                this.setState({ cargando: false });
                console.log(err)
                openNotification(
                    "Ha ocurrido un error al eliminar el inventario. Favor de intentarlo más tarde",
                    "Error"
                )
            })
        })
    }

    erroreSAP = (value, record) => {
        let state = { ...this.state };
        this.setState({ cargando: true }, () => {
            InventarioRequest.SincronizarInventarioSAP(state.driveSelected, this.props.match.params.esExterno, record.id).then(response => {
                state.paginacion = {
                    current: 1,
                    total: response.data.count,
                    onChange: this.handlePaginaChange,
                    pageSize: 100,
                    showTitle: false
                }
                state.bloquear_guardar = false;
                let today = new Date().toLocaleDateString();
                response.data.results.find((item) => {
                    let toDy = new Date(item.Fecha);
                    item.Fecha2 = new Date(item.Fecha);
                    item.Fecha2.setHours(item.Fecha2.getHours() + 7);
                    item.FechaStr = toDy.toLocaleDateString();
                    if (today != item.FechaStr) {
                        toDy.setDate(toDy.getDate() + 1)
                        item.FechaStr = toDy.toLocaleDateString();
                    }
                    if (item.FechaStr == today && item.Estatus != 5) {
                        state.bloquear_guardar = true;
                    }
                });

                state.cargando = false;
                state.arrListaInventario = response.data.results
                state.disableRange = false;
                this.setState(state)
            }).catch(err => {
                this.setState({ cargando: false });
                console.log(err)
                openNotification(
                    "Ha ocurrido un error al sincronizar con SAP. Favor de intentarlo más tarde",
                    "Error"
                )
            })
        })
    }
    
    showConfirm = (value) => {
        confirm({
            title: 'Confirmar Eliminar',
            content: <div><b>¿Está seguro de eliminar este registro?</b></div>,
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            okButtonProps: {
                id: 'boton-aceptar-confirmacion-capturar-inventario-form',
            },
            cancelButtonProps: {
                id: 'boton-cancelar-confirmacion-capturar-inventario-form',
            },
            onOk: () => {
                this.deleteInv(value)
            },
        });
    }

    render() {
        const columnasInventario = [
            {
                title: "Fecha y hora de captura",
                dataIndex: "Fecha2",
                key: "Fecha2",
                render: fecha => {
                    return (
                        <span>
                            {moment(fecha).format("DD/MM/YYYY, h:mm a")}
                        </span>
                    )
                }
            },
            {
                title: "Usuario que capturó",
                dataIndex: "usuario",
                key: "usuario",
                render: usuario => {
                    return (
                        <span>
                            {usuario}
                        </span>
                    )
                }
            },
            {
                title: "Estado",
                dataIndex: "Estatus",
                key: "Estatus",
                render: (value, record) => {
                    return (
                        <span style={{ fontWeight: "bold", color: getStatusInvColor(value) }}> {getStatusInv(value)}</span>
                    )
                }
            },
            {
                title: "Inventario Número",
                dataIndex: "Refencia",
                key: "Refencia",
                render: Refencia => {
                    return (
                        <span>
                            {Refencia}
                        </span>
                    )
                }
            },
            {
                title: 'Acciones',
                dataIndex: 'Acciones',
                key: 'Acciones',
                render: (value, record) => (
                    <div>
                        <span style={{ marginRight: 5 }}>
                            <Tooltip placement="top" title={"Ver detalle de inventario"}>
                                <Button icon="eye" className="btnVerCrearGuardar" onClick={() => this.showForm('detalle', value, record)}></Button>
                            </Tooltip>
                        </span>
                        <span style={{ marginRight: 5 }}>
                            <Tooltip placement="top" title={"Editar inventario"}>
                                <Link to={"/editInventario/" + this.state.driveSelected + "/" + record.id}>
                                    <Button icon="edit" className="btnEditar" disabled={(record.Estatus != 0 && record.Estatus != 1 && record.Estatus != 2) || (this.state.FechaStr != record.FechaStr)}></Button>
                                </Link>
                            </Tooltip>
                        </span>
                        <span style={{ marginRight: 5 }}>
                            <Tooltip placement="top" title={"Sincronizar SAP"}>
                                <Button icon="redo" className="btnEditar" onClick={() => this.sincSAP(value, record)} disabled={(record.Estatus != 4) || (this.state.FechaStr != record.FechaStr)}></Button>
                            </Tooltip>
                        </span>
                        {record.Estatus === 4 &&
                            <span style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Detalles SAP"}>
                                    <Button icon="warning" className="btnEditar" onClick={() => this.showFormSAP('detalle', value, record)}></Button>
                                </Tooltip>
                            </span>
                        }
                        {(record.Estatus === 0 || record.Estatus === 1 || record.Estatus === 2) &&
                            <span style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Eliminar"}>
                                    <Button icon="delete" className="btnEditar" onClick={() => this.showConfirm(record) /*this.deleteInv(value, record)*/}></Button>
                                </Tooltip>
                            </span>
                        }
                    </div>
                )
            }
        ]

        return (
            <Card id="ParentSize"
                title={'Captura de inventario'}
                extra={
                    <div>
                        <Link to={"/nuevoInventario/" + this.state.driveSelected}>
                            <Button
                                className="btnVerCrearGuardar"
                                disabled={this.state.bloquear_guardar}
                                type="primary"
                                id="boton-guardar-inventario-modulo"
                            > Agregar Inventario </Button>
                        </Link>
                    </div>
                }
            >
                <div className="panel-block">
                    <div style={{ marginBottom: "20px" }}>
                        <Row gutter={24}>
                            <Col span={8}>
                                <Tooltip placement="top" title="Punto de venta">
                                    <div className="center">Punto de venta:</div>
                                    <Select
                                        defaultActiveFirstOption={false}
                                        allowClear={this.state.arrDrives?.length > 1}
                                        showSearch
                                        disabled={this.state.disable_combo_drive}
                                        notFoundContent={"No hay opciones"}
                                        style={{ width: "100%" }}
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        filterOption={(input, option) => sanitizerTexto(input, option.props.children)}
                                        value={this.state.driveSelected}
                                        onChange={(value) => {
                                            this.setState({ driveSelected: value }, this.onChangeDrive)
                                        }}
                                    >
                                        <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrDrives?.length > 0 &&
                                            this.state.arrDrives.map((obj, index) => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                        </Row>
                    </div>
                    {<Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={(_, index) => index}
                            columns={columnasInventario}
                            dataSource={this.state.arrListaInventario}
                            pagination={this.state.paginacion}
                        />
                    </Spin>}
                </div>
                <VistaInventario
                    esconderModal={this.esconderModal}
                    visible={this.state.visible}
                    type={this.state.typeForm}
                    inventario={this.state.objInventario}
                    drive_selected={this.state.driveSelected}
                    esExterno={this.props.match.params.esExterno}
                />
                <DetallesSAP
                    esconderModal={this.esconderModal}
                    visible={this.state.visibleSAP}
                    type={this.state.typeForm}
                    inventario={this.state.objInventario}
                    drive_selected={this.state.driveSelected}
                    esExterno={this.props.match.params.esExterno}
                />
            </Card>
        )
    }


}